const CURRENCY_MODEL_CLASS_NAME = 'Currency'

const CURRENCY_MODEL_KEY = {
  NAME: 'name',
  VALUE: 'value'
}

const CURRENCY_MODEL_KEY_POINTER = CURRENCY_MODEL_KEY.NAME

export {
  CURRENCY_MODEL_CLASS_NAME,
  CURRENCY_MODEL_KEY,
  CURRENCY_MODEL_KEY_POINTER
}
